import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
  Table,
} from "antd";
import { useEffect, useState } from "react";
import moment from "moment";
import { API } from "../../config/api";
import { POST } from "../../utils/apicalls";
import PageHeader from "../../admin/pageHeader/pageheader";
import { useSelector } from "react-redux";

function LeaveDetails() {
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const user = useSelector((state: any) => state.user);
  const [data, setData] = useState<any>();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [meta, setMeta] = useState<any>({});
  const [selectdata, setselectData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const columns = [
    {
      dataIndex: "type",
      title: "type",
    },
    {
      dataIndex: "approver",
      title: "approver",
    },
    {
      dataIndex: "from",
      title: "from",
      render: (from: any) => (from ? moment(from).format("DD/MM/YYYY") : "-"),
    },
    {
      dataIndex: "to",
      title: "to",
      render: (to: any) => (to ? moment(to).format("DD/MM/YYYY") : "-"),
    },
    {
      dataIndex: "status",
      title: "Status",
      render: (status: any) => {
        let color = "";
        switch (status?.toLowerCase()) {
          case "approved":
            color = "green";
            break;
          case "rejected":
            color = "red";
            break;
          default:
            color = "black"; // Default color for other statuses
        }
        return <span style={{ color }}>{status}</span>;
      },
    },
    {
      dataIndex: "employeeId",
      title: "employeeId",
      render: (_: any, value: any) => <span>{value?.empid?.fullName}</span>,
    },
    {
      dataIndex: "description",
      title: "description",
    },
    {
      dataIndex: "createdBy",
      title: "createdBy",
    },
  ];

  const showModal = () => {
    setIsModalOpen(true); // Open the modal
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const filterEmployee = async () => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),
        type: "telecaller",
        status: true,
      };
      const url = API.FILTER_EMPLOYEE;
      const response: any = await POST(url, obj);
      setselectData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    filterEmployee(); // Fetch data when the component mounts
  }, []);

  const submitHandler = async (values: any) => {
    try {
      let obj = {
        employeeId: user.id,
        salaryId: values.salaryId,
        leaveId: values.leaveId,
        approver: values.approver,
        from: values.from,
        to: values.to,
        type: values.type,
        status: values.status,
        description: values.description,
        createdBy: values.createdBy,
      };

      setIsLoading(true);
      const api = API.CREATE_LEAVE;
      const postRequest: any = await POST(api, obj);
      if (postRequest.status) {
        notification.success({ message: "Leave created successfully!" });
        setIsLoading(false);
        setIsModalOpen(false);
        form.resetFields();
      } else {
        notification.error({ message: "Something went wrong" });
      }
    } catch (error) {
      console.log(error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const fetchLeave = async (page: any, values: any) => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),
        page: page,
        take: 10,
        employeeId: user.id,
      };
      const url = API.LIST_LEAVE;
      const response: any = await POST(url, obj);
      setData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchLeave(page, pageSize);
  }, [page, pageSize]);

  return (
    <div>
      <PageHeader>
        <Row
          gutter={16}
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Col>
            {" "}
            <Button
              type="primary"
              onClick={showModal}
              style={{ marginRight: "10px" }}
            >
              Create leave
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div>
        <Card>
          {" "}
          {/* <Form form={form} onFinish={search} layout="vertical">
            {" "}
            <Row gutter={16}>
              {" "}
              <Col sm={6}>
                {selectdata && (
                  <Form.Item
                    label="Employee Name"
                    name="employeeId"
                    style={{ marginBottom: 10 }}
                  >
                    <Select
                      placeholder="Select an employee"
                      size="large"
                      allowClear
                    >
                      {selectdata?.map((users: any, i: any) => (
                        <Select.Option
                          key={users?.id}
                          value={Number(users?.id)}
                        >
                          {users?.fullName}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}
              </Col>
              <Col span={6}>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={isLoading}
                    block
                  >
                    search
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form> */}
        </Card>
      </div>

      <Modal
        title="Create leave"
        visible={isModalOpen}
        onCancel={handleCancel}
        width={1000}
        footer={false}
      >
        <Form form={form} onFinish={submitHandler} layout="vertical">
          <Row gutter={16}>
            <Col sm={6}>
              <Form.Item
                name="from"
                label="from"
                rules={[{ required: true, message: "Select startDate" }]}
              >
                <DatePicker />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="to"
                label="to"
                rules={[{ required: true, message: "Select startDate" }]}
              >
                <DatePicker />
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item
                name="description"
                label="description"
                rules={[{ required: true, message: "Enter feedback" }]}
              >
                <Input.TextArea placeholder="description" />
              </Form.Item>
            </Col>

            {/* <Col sm={6}>
              <Form.Item name="status" label="status">
                <Input placeholder="status" />
              </Form.Item>
            </Col> */}

            {/* <Col sm={6}>
              {selectdata && (
                <Form.Item
                  label="Employee Name"
                  name="employeeId"
                  style={{ marginBottom: 10 }}
                  rules={[{ required: true }]}
                >
                  <Select placeholder="Select an employee" size="large">
                    {selectdata?.map((users: any, i: any) => (
                      <Select.Option key={users?.id} value={Number(users?.id)}>
                        {users?.fullName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              )}
            </Col> */}

            <Col sm={6}>
              <Form.Item
                name="type"
                label="Leave Type"
                rules={[{ required: true, message: "Select leave type" }]}
              >
                <Select placeholder="Select leave type">
                  <Select.Option value="sick">Sick</Select.Option>
                  <Select.Option value="vacation">Vacation</Select.Option>
                  <Select.Option value="maternity">Maternity</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="createdBy" label="createdBy">
                <Input placeholder="createdBy" />
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item
                name="status"
                label="status"
                rules={[{ required: true, message: "Please select a status!" }]}
              >
                <Select placeholder="Select status">
                  <Select.Option value="requested">requested</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={isLoading}
                  block
                >
                  Create leave
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>

      <Card>
        <Table columns={columns} dataSource={data} />
      </Card>
    </div>
  );
}

export default LeaveDetails;
